import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-75e13ea9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "h100 flex fx-b fy-c pl-10"
};
const _hoisted_2 = {
  class: "tc"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "blank"
}, null, -1));
import { computed, reactive } from 'vue';
import store from '@/store';
import router from '@/router';
import { Menu } from '@element-plus/icons-vue';
import HeadMenu from './components/HeadMenu.vue';
import HeadRight from './components/HeadShopLink.vue';
import menuList from '@/assets/data/menu';
export default {
  __name: 'HeaderView',
  setup(__props) {
    const global = store.state.bk.global;
    let isMobile = computed(() => global.isMobile);
    let currentRouteIndex = computed(() => global.currentRoute);
    const logoUrl = './imgs/logo.png';
    const data = reactive({
      asideMenu: false
    });
    const menuToggle = () => {
      data.asideMenu = !data.asideMenu;
    };
    const selectHandler = index => {
      menuToggle();
      router.push(menuList[index].path);
      scrollTo(0, 0);
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: _normalizeClass(['header', _unref(isMobile) ? 'h5' : 'pc'])
      }, [!_unref(isMobile) ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        class: "h100"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          class: "flex fx-c",
          span: 5
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: "/",
            class: "h100 flex fy-c"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_image, {
              src: logoUrl,
              fit: "contain",
              loading: "lazy",
              style: {
                "width": "86px",
                "height": "44px"
              }
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          class: "flex fy-c",
          span: 19
        }, {
          default: _withCtx(() => [_createVNode(HeadMenu, {
            activeMenu: _unref(currentRouteIndex)
          }, null, 8, ["activeMenu"])]),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_image, {
          src: logoUrl,
          fit: "contain",
          loading: "lazy",
          style: {
            "height": "36px",
            "width": "67px"
          }
        })]),
        _: 1
      }), _createElementVNode("div", {
        class: "px-10",
        onClick: menuToggle
      }, [_createVNode(_component_el_icon, {
        size: "22",
        color: "#606266"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Menu))]),
        _: 1
      })])]))], 2), _createVNode(_component_el_drawer, {
        modelValue: data.asideMenu,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.asideMenu = $event),
        size: "50%"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_image, {
          src: logoUrl,
          fit: "contain",
          loading: "lazy",
          style: {
            "height": "44px"
          }
        })]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), li => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(['aside-item tc', {
              active: _unref(currentRouteIndex) === li.id
            }]),
            key: li.id,
            onClick: $event => selectHandler(li.id)
          }, _toDisplayString(li.label), 11, _hoisted_3);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _hoisted_4]);
    };
  }
};